import { getServerTime } from "../api/index";

export const MAX_EXAM_CLOCK_SKEW_MS = 5 * 60 * 1000;

function getServerTimestamp(response) {
  const data = response && response.data && response.data.data;
  if (!data) return null;
  if (Number.isFinite(Number(data.server_time_ms))) {
    return Number(data.server_time_ms);
  }
  if (Number.isFinite(Number(data.server_time))) {
    return Number(data.server_time) * 1000;
  }
  return null;
}

export async function measureExamClock() {
  const requestStartedAt = Date.now();
  const response = await getServerTime({
    timeout: 10000,
    skipNetworkErrorMessage: true,
  });
  const requestFinishedAt = Date.now();
  const serverTimeMs = getServerTimestamp(response);

  if (!serverTimeMs) {
    throw new Error("The exam server did not return a valid time.");
  }

  const roundTripMs = requestFinishedAt - requestStartedAt;
  const clientMidpointMs = requestStartedAt + roundTripMs / 2;
  const clockSkewMs = clientMidpointMs - serverTimeMs;

  return {
    valid: Math.abs(clockSkewMs) <= MAX_EXAM_CLOCK_SKEW_MS,
    clockSkewMs,
    serverTimeMs: serverTimeMs + Math.max(0, roundTripMs / 2),
    clientTimeMs: requestFinishedAt,
    roundTripMs,
  };
}

export function describeClockSkew(clockSkewMs) {
  const absoluteMinutes = Math.max(1, Math.round(Math.abs(clockSkewMs) / 60000));
  let duration = `${absoluteMinutes} minute(s)`;
  if (absoluteMinutes >= 60) {
    const hours = Math.floor(absoluteMinutes / 60);
    const minutes = absoluteMinutes % 60;
    duration = `${hours} hour(s)${minutes ? ` ${minutes} minute(s)` : ""}`;
  }
  return `${duration} ${clockSkewMs > 0 ? "ahead of" : "behind"}`;
}

export function buildClockErrorMessage(clockSkewMs) {
  return [
    `Your computer clock is ${describeClockSkew(clockSkewMs)} the exam server.`,
    "For exam safety, entry is blocked until the clock is corrected.",
    "Open Date & Time settings, enable automatic time, select the correct time zone, and sync the clock before trying again.",
  ].join(" ");
}
